/**
 * What: Renders standalone card components for the Shopify settings page, with Polaris App Home
 * web components instead of classic @shopify/polaris React — same copy/links as SettingsPage.tsx,
 * migrated render layer only.
 * Transport / data-flow: Pure presentational layout components.
 *
 */

import { shopifyComponentCopy } from '@testfeed/product-language'
import { buildCalendlyBookingUrl, buildSupportViewUrl } from '../resultsNavigation'
import { TestReviewHelp } from './TestReviewHelp'

/** Card explaining data synchronization, privacy safeguards, and aggregated metrics. */
export function DataSafetyPrivacyCardPolaris() {
  return (
    <s-stack direction="block" gap="base">
      <s-paragraph>{shopifyComponentCopy.settingsPage.storeIntelligenceIsAnalyzedAnd001}</s-paragraph>
      <s-paragraph>{shopifyComponentCopy.settingsPage.testfeedIsDesignedWithPrivacy002}</s-paragraph>
      <s-stack direction="block" gap="small-200">
        <s-heading>{shopifyComponentCopy.settingsPage.privacySafeguards003}</s-heading>
        <s-unordered-list>
          <s-list-item>
            <s-text color="subdued">{shopifyComponentCopy.settingsPage.zeroCustomerPiiNoNames004}</s-text>
          </s-list-item>
          <s-list-item>
            <s-text color="subdued">
              {shopifyComponentCopy.settingsPage.statisticalGroundingCustomerSegmentsAre005}
            </s-text>
          </s-list-item>
        </s-unordered-list>
      </s-stack>
    </s-stack>
  )
}

/** Card exposing support buttons, strategic booking, and documentation resources. */
export function SupportResourcesCardPolaris() {
  return (
    <TestReviewHelp
      variant="large"
      bookingUrl={buildCalendlyBookingUrl({ source: 'settings' })}
      supportUrl={buildSupportViewUrl()}
    />
  )
}
